import Cookies from 'js-cookie'
import {
  Toast
} from 'vant'
window.ApiHashs = []
window.LastApiTime = new Date().getTime()
var InnerRequest = function (obj) {
  var defaultOpts = {
    url: localStorage.getItem('BASE_API_1') ? localStorage.getItem('BASE_API_1') : process.env.BASE_API_1
  }
  Cookies.set('url', defaultOpts.url)
  if (obj.IsRequests) {
    defaultOpts.url = localStorage.getItem('BASE_API_1') ? localStorage.getItem('BASE_API_1') + 's' : `${process.env.BASE_API_1}s`
  }

  //   var defaultOpts = {
  //     url: process.env.BASE_API_1
  //   }
  //   if (obj.IsRequests) {
  //     defaultOpts.url = `${process.env.BASE_API_1}s`
  //   }
  delete obj.IsRequests
  var hash = obj.hash
  delete obj.hash
  return new Promise((resolve, reject) => {
    var xhr = null
    var ajax = {
      init: function () {
        ajax.createXHR()
      },
      options: {
        timeoutFlag: null,
        timeoutBool: false
      },
      timeout: function (callback, script) {
        if (defaultOpts.timeout !== undefined) {
          ajax.options.timeoutFlag = setTimeout(function () {
            ajax.options.timeoutBool = true
            xhr && xhr.abort()
            defaultOpts.timeout(args)
            RemoveHash(hash)
          }, 7000)
        }
      },
      getXHR: function () {
        if (window.XMLHttpRequest) {
          return new XMLHttpRequest()
        }
      },
      createXHR: function () {
        xhr = ajax.getXHR()
        xhr.open('POST', defaultOpts.url, true)
        xhr.timeout = defaultOpts.timeout
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*')
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.setRequestHeader('token', Cookies.get('token'))
        xhr.setRequestHeader('uid', Cookies.get('uid'))
        xhr.setRequestHeader('Channel', '5')

        if (obj.retry === '') {
          xhr.setRequestHeader('retry', ' ')
        }
        delete obj.retry
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            RemoveHash(hash)
            if (xhr.status === 200) {
              resolve(xhr)
            } else if (xhr.status === 500) {
              Toast.loading({
                type: 'fail',
                overlay: true,
                message: '服务器错误!',
                duration: 3000
              })
              Cookies.remove('token')
              Cookies.remove('uid')
              Cookies.remove('appID')
              Cookies.remove('account')
              reject(xhr)
            } else if (xhr.status === 501) {
              Toast.loading({
                type: 'fail',
                overlay: true,
                message: '抱歉,当前访问的页面需要登录!',
                duration: 3000,
                onClose: () => {
                  window.location.href = '/signIn'
                }
              })
              Cookies.remove('token')
              Cookies.remove('uid')
              Cookies.remove('appID')
              Cookies.remove('account')
              reject(xhr)
            } else if (xhr.status === 502) {
              Toast.loading({
                type: 'fail',
                overlay: true,
                message: '抱歉,您的账号在另一个地方登陆,请重新登录!',
                duration: 3000,
                onClose: () => {
                  window.location.href = '/signIn'
                }
              })
              Cookies.remove('token')
              Cookies.remove('uid')
              Cookies.remove('appID')
              Cookies.remove('account')
            } else {
              Toast.loading({
                type: 'fail',
                overlay: true,
                message: xhr.response || xhr.status,
                duration: 3000
              })
              setTimeout(() => {
                reject(xhr)
              }, 3000)
            }
          }
        }
        xhr.send(JSON.stringify(obj))
        ajax.timeout()
      }
    }
    ajax.init()
  })
}
var Request = function (obj) {
  var isRequests = false
  if (obj.IsRequests) {
    isRequests = true
  }
  return InnerRequest(obj)
    .then(r => {
      var data
      if (r.responseText != '' && r.responseText[0] == '{') {
        data = JSON.parse(r.responseText)
        if (isRequests) {
          data = data.HttpRequestResponses
          // data = JSON.parse(data.HttpRequestResponses)
          // 多并发请求时解析json字符串为对象
          if (data.length) {
            data.map(item => {
              item.Json = JSON.parse(item.Json)
            })
          }
        }
      } else {
        data = r.responseText
      }
      return Promise.resolve(data)
    })
    .catch(xhr => {
      let errMsg = xhr.response || xhr.status
      return Promise.reject(errMsg)
    })
}

var SetObjHash = function (obj) {
  var json = JSON.stringify(obj)
  var hash = 0
  var charCode = 0
  for (var i = 0; i < json.length; i++) {
    charCode = json.charCodeAt(i)
    hash = (hash << 5) - hash + charCode
    hash = hash & hash
  }
  if (window.ApiHashs.indexOf(hash) < 0) {
    window.ApiHashs.push(hash)
    return hash
  } else {
    return 0
  }
}

var RemoveHash = function (hash) {
  try {
    var a = window.ApiHashs.indexOf(hash)
    if (a >= 0) {
      window.ApiHashs.splice(a, 1)
    }
  } catch (e) {
    console.log(e + '删除数组内容失败')
  }
}

export function ApiExecute() {
  var allApis = []
  for (let index = 0; index < arguments.length; index++) {
    var arg = arguments[index]
    if (Array.isArray(arg)) {
      allApis = allApis.concat(arg)
    } else {
      allApis.push(arg)
    }
  }
  var messages = []
  for (let index = 0; index < allApis.length; index++) {
    const api = allApis[index]
    if (api != null) {
      var message = {
        AppID: 0,
        Method: '',
        RequestObjs: []
      }
      var i = 0
      for (var key in api) {
        if (i === 0) {
          if (api[key] === 12) {
            alert(api[key] + '接口报错,请截图发前端')
          }
          message.AppID = api[key]
        } else if (i === 1) {
          message.Method = api[key]
        } else {
          if (!key.endsWith('$')) {
            if (api[key] == null) {
              message.RequestObjs.push('')
            } else {
              message.RequestObjs.push(api[key].toString())
            }
          }
        }
        i = i + 1
      }
      messages.push(message)
    }
  }
  if (messages.length === 0) {
    return
  } else {
    var obj
    if (messages.length === 1) {
      obj = messages[0]
      if (new Date().getTime() - window.LastApiTime <= 2000) {
        obj.retry = ''
      }
      if (
        obj.Method.indexOf('Get') == -1 ||
        obj.Method.indexOf('DownLoad') == -1 ||
        obj.Method.indexOf('Search') == -1 ||
        obj.Method.indexOf('Check') == -1
      ) {
        window.LastApiTime = new Date().getTime()
      }
    } else {
      obj = {
        AppID: 15,
        HttpCommands: messages,
        IsRequests: 1
      }
      if (new Date().getTime() - window.LastApiTime <= 2000) {
        obj.retry = ''
      }
      window.LastApiTime = new Date().getTime()
    }
    var hash = SetObjHash(message)
    obj.hash = hash
    return Request(obj)
  }
}


// WEBPACK FOOTER //
// ./src/utils/tool.js